"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const DeviceClient_1 = require("./DeviceClient");
const PresentationClient_1 = require("./PresentationClient");
const PlaylistClient_1 = require("./PlaylistClient");
const ResourceClient_1 = require("./ResourceClient");
const urls_1 = __importDefault(require("./urls"));
const mapNestedFolderResponse = (f) => ({
    id: f.id,
    name: f.name,
    type: f.type,
    description: f.description,
    resource: (0, ResourceClient_1.mapResourceResponse)(f.resource),
});
const mapFolderResponse = (f) => ({
    id: f.id,
    name: f.name,
    type: f.type,
    path: f.path || [],
    description: f.description,
    devices: (f.devices || []).map(DeviceClient_1.mapDeviceResponse),
    presentations: (f.presentations || []).map(PresentationClient_1.mapPresentationResponse),
    playlists: (f.playlists || []).map(PlaylistClient_1.mapPlaylistResponse),
    folders: (f.folders || []).map(mapNestedFolderResponse),
    resource: (0, ResourceClient_1.mapResourceResponse)(f.resource),
});
const mapVirtualFolderResponse = (f) => ({
    devices: (f.devices || []).map(DeviceClient_1.mapDeviceResponse),
    presentations: (f.presentations || []).map(PresentationClient_1.mapPresentationResponse),
    playlists: (f.playlists || []).map(PlaylistClient_1.mapPlaylistResponse),
    folders: (f.folders || []).map(mapNestedFolderResponse),
});
class FolderClient {
    getDevicesFolder(query) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'GET',
                url: urls_1.default.devicesFolder(query),
            });
            return mapVirtualFolderResponse(data);
        });
    }
    getV4DevicesFolder(query) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'GET',
                url: urls_1.default.v4DevicesFolder(query),
            });
            return mapVirtualFolderResponse(data);
        });
    }
    getV5DevicesFolder(query) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'GET',
                url: urls_1.default.v5Devices(query),
            });
            const v5DevicesResponse = data.data || [];
            const v3DevicesResponse = v5DevicesResponse.map((d) => (0, DeviceClient_1.mapV5DeviceToV3Device)(d));
            const virtualFolderResponse = {
                devices: v3DevicesResponse,
                presentations: [],
                playlists: [],
                folders: [],
            };
            return mapVirtualFolderResponse(virtualFolderResponse);
        });
    }
    getLibraryFolder() {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'GET',
                url: urls_1.default.libraryFolder(),
            });
            return mapVirtualFolderResponse(data);
        });
    }
    getV4LibraryFolder(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'GET',
                url: params
                    ? `${urls_1.default.v4DevicesLibrary()}?${new URLSearchParams(params).toString()}`
                    : `${urls_1.default.v4DevicesLibrary()}`,
            });
            return mapVirtualFolderResponse(data);
        });
    }
    getV4LibraryLiteFolder(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'GET',
                url: params
                    ? `${urls_1.default.v4DevicesLibraryLite()}?${new URLSearchParams(params).toString()}`
                    : `${urls_1.default.v4DevicesLibraryLite()}`,
            });
            return mapVirtualFolderResponse(data);
        });
    }
    getFolder(folderId) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'GET',
                url: urls_1.default.folder(folderId),
            });
            return mapFolderResponse(data);
        });
    }
    createFolder(folder) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'POST',
                url: urls_1.default.folders(),
                body: {
                    name: folder.name,
                    description: folder.description,
                    type: folder.type,
                },
            });
            return mapFolderResponse(data);
        });
    }
    updateFolder(folderId, folder) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'PATCH',
                url: urls_1.default.folder(folderId),
                body: {
                    name: folder.name || '',
                    description: folder.description || '',
                },
            });
            return mapFolderResponse(data);
        });
    }
    deleteFolder(folderId) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'DELETE',
                url: urls_1.default.folder(folderId),
            });
            return data;
        });
    }
    moveFolderToFolder(folderId, parentFolderId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.requestProtected({
                method: 'POST',
                url: urls_1.default.folderMoveToFolder(folderId),
                body: {
                    folder_id: parentFolderId,
                },
            });
        });
    }
}
exports.default = FolderClient;
